// Escala semántica compartida del módulo de Bienestar Corporativo: un puntaje 0-100 (índice,
// adopción, cumplimiento) se pinta con los tokens del semáforo de sesiones, nunca con el dorado
// (que queda reservado como acento pequeño). Vive aparte del tab para que el panel de detalle
// pueda usarla sin importar el tab (import circular).

export const toneOf = (score) => {
  if (score === null || score === undefined) return 'text.disabled';
  if (score >= 70) return 'sessionStatus.completed.fg';
  if (score >= 50) return 'sessionStatus.pending.fg';
  return 'sessionStatus.absent.fg';
};

export const bgOf = (score) => {
  if (score === null || score === undefined) return 'surface.overlay';
  if (score >= 70) return 'sessionStatus.completed.bg';
  if (score >= 50) return 'sessionStatus.pending.bg';
  return 'sessionStatus.absent.bg';
};

export default toneOf;
